let BACKEND_SERVER = "https://api.projectivetech.com/";
//let BACKEND_SERVER = "http://127.0.0.1:8000/"

const config = {
  basename: '',
  defaultPath: '/imagei/overview',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  API_SERVER: BACKEND_SERVER
};

export default config;
